import Cookies from 'js-cookie';
import dayjs from './dayjs';

// SSR-safe: isCordova() checks typeof window !== 'undefined', so localStorage
// calls inside if (isCordova()) blocks are never reached during SSR.
import { isCordova } from './mobile/deviceDetection';

/**
 * @param {string} key
 * @returns {any}
 */
export const getClientData = (key) => {
  let data;
  if (isCordova()) {
    const dataFromStorage = JSON.parse(window.localStorage.getItem(key));
    if (
      dataFromStorage &&
      dataFromStorage.expires &&
      dayjs().isAfter(dayjs(dataFromStorage.expires))
    ) {
      data = null;
      deleteClientData(key);
    } else {
      data = dataFromStorage?.value || null;
    }
  } else {
    data = Cookies.get(key) ? JSON.parse(Cookies.get(key)) : null;
  }
  return data;
};

export const getAllClientData = () => {
  let data;
  if (isCordova()) {
    data = {};
    const storage = window.localStorage;
    for (let i = 0; i < storage.length; i++) {
      if (getClientData(storage[i])) {
        data[storage[i]] = getClientData(storage[i]);
      }
    }
  } else {
    data = Cookies.get();
  }
  return data;
};

/**
 * @param {string} key
 * @param {any} value
 * @param {Date | number | string | import('dayjs').Dayjs} expires
 * @param {object} [cookieOptions] web only — extra js-cookie attributes (sameSite, secure)
 */
export const setClientData = (key, value, expires, cookieOptions = {}) => {
  if (isCordova()) {
    const data = { value, expires: dayjs(expires).toISOString() };
    window.localStorage.setItem(key, JSON.stringify(data));
  } else {
    Cookies.set(key, JSON.stringify(value), {
      expires: dayjs(expires).toDate(),
      ...cookieOptions,
    });
  }
};

export const deleteClientData = (key) => {
  if (isCordova()) {
    window.localStorage.removeItem(key);
  } else {
    Cookies.remove(key);
  }
};
